<template>
  <div class="diy-notification" :class="notificationClassType">
    <!-- icon -->
    <div class="diy-notification__icon">
      <AppIcon v-if="notification.icon" :icon="notificationIcon" />
    </div>
    <div class="diy-notification__content">
      <!-- heading -->
      <div v-if="notification.heading" class="diy-notification__heading">
        <AppHeading tag="h4" :text="notification.heading" />
      </div>
      <!-- message -->
      <div class="diy-notification__message">
        {{ notification.message }}
      </div>
    </div>
  </div>
</template>

<script>
// Utilities
import { mapActions } from 'vuex'
// Components
import AppIcon from 'Ui/AppIcon'
import AppHeading from 'Ui/AppHeading'

export default {
  name: 'NotificationSingle',

  components: {
    AppIcon,
    AppHeading,
  },

  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      timeout: null,
    }
  },

  mounted() {
    this.timeout = setTimeout(
      () => this.remove(this.notification),
      this.notification.timeout || 2500
    )
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },

  computed: {
    notificationIcon() {
      const type = this.notification.type
      if (type === 'info') return 'far fa-info-circle'
      if (type === 'success') return 'far fa-check-double'
      if (type === 'error') return 'far fa-exclamation-circle'
      if (type === 'alert') return 'far fa-exclamation-triangle'
      return false
    },

    notificationClassType() {
      return `diy-notification-text--${this.notification.type}`
    },
  },

  methods: mapActions('notifications', ['remove']),
}
</script>

<style scoped>
.diy-notification {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  align-items: center;
  justify-content: center;
  max-width: 340px;
  font-size: 14.5px;
  line-height: 16px;
  font-weight: 600;
  letter-spacing: 0.6px;
  color: #fff;
  padding: 20px 15px;
  border-radius: 4px 0 0 4px;
  user-select: none;
  transition: 0.3s;
}

.diy-notification:not(:last-of-type) {
  margin-bottom: 10px;
}

.diy-notification__message {
  font-size: 13px;
  line-height: 18px;
}

.diy-notification__icon .app-icon {
  font-size: 17px;
}

.diy-notification-text--error {
  background-color: var(--c-bright-red-500);
}

.diy-notification-text--success {
  color: #fff;
  background-color: var(--c-aquamarine-800);
}

.diy-notification-text--info {
  background-color: var(--c-secondary-700);
}

.diy-notification-text--alert {
  background-color: var(--c-yellow-500);
}

/* Responsive ----- */
@media (max-width: 480px) {
  .diy-notification {
    max-width: 250px;
    padding: 10px;
  }
}
</style>
